/**
 * 전자작업확인서 조회·재생성 (/adm/order/confirmation?orderno=…&odr=…) — 관리자 틀 없는 단독 창
 * ($j.Pages.Admin.OrderConfirmation / body data-page-name="OrderConfirmation")
 *
 * 세 가지 상태: 오더번호 입력 / 서버 오류 안내 후 입력으로 / 문서 보기(차수 고르기·재생성·인쇄).
 * 재생성은 숨김 iframe 을 html2canvas 로 캡처하는 public/js/order-confirm-capture.js(OrderConfirmCapture) 를 쓴다.
 */
let ordernum = null;

export default class OrderConfirmation {
    initialize() {
        const d = JSON.parse(document.getElementById('page-data').textContent);
        ordernum = d.ordernum;

        if (d.result) {
            alert(d.result);
            window.location.href = '/adm/order/confirmation';
            return;
        }
        $('#odrsel').on('change', reload);
        $('#btn-regen').on('click', regen);
        $('#btn-print').on('click', printDoc);
        $('#btn-ordern').on('click', ordernumdo);
    }
}

function currentOdr() { return document.getElementById('odrsel').value; }

function reload() {
    document.location.href = '/adm/order/confirmation?orderno=' + ordernum + '&odr=' + currentOdr();
}

function printDoc() {
    var f = document.getElementById('docframe');
    f.contentWindow.focus();
    f.contentWindow.print();
}

function regen() {
    var btn = document.getElementById('btn-regen');
    var msg = document.getElementById('msg');
    var odr = currentOdr();

    btn.disabled = true;
    msg.className = 'ocd-msg';
    msg.textContent = '문서를 이미지로 생성하는 중…';

    OrderConfirmCapture.save({
        // 저장되는 정본은 항상 사진 없는 버전 (모바일 재서명 저장본과 동일 기준)
        docUrl: '/adm/order/confirm-doc?orderno=' + ordernum + '&odr=' + odr + '&mode=plain',
        saveUrl: '/adm/order/confirm-image',
        params: { orderno: ordernum, odr: odr }
    }).then(function (r) {
        btn.disabled = false;
        if (r && r.result) {
            msg.className = 'ocd-msg ok';
            msg.textContent = odr + '차 작업확인서를 재생성했습니다. (이미지 #' + r.img_id + ')';
        } else {
            msg.className = 'ocd-msg err';
            msg.textContent = (r && r.message) || '재생성에 실패했습니다.';
        }
    }).catch(function (e) {
        btn.disabled = false;
        msg.className = 'ocd-msg err';
        msg.textContent = e.message || '재생성에 실패했습니다.';
    });
}

function ordernumdo() {
    var onum = parseInt(document.getElementById('ordern').value);
    if (isNaN(onum)) onum = 0;
    if (onum > 10) {
        document.location.href = '/adm/order/confirmation?orderno=' + onum;
    } else {
        alert('오더번호를 숫자로 입력해 주세요');
    }
}
